export const SET_CONFIGURATION_FILE = "SET_CONFIGURATION_FILE";